export default __webpack_public_path__ + "static/media/contentManagement.f20956bd.svg";